import { waitForMs } from '../Utils/AsyncUtils';
import { Storage } from '../Utils/Storage';
import { ISGSettings, ISGTrackData } from './SDK';
import { IMediaParams } from './SDKmessages';
import { IFBFriend } from './SDKfb';
import { IRewardItem } from '../State/reducers/score';
import { getIsWeb } from '../Utils/Platform';
import ContextPlayer = FBInstant.ContextPlayer;
import { ISDKpayments } from './ISDKpayments';
import { SDKlocalpayments } from './SDKlocalpayments';
import { getBrowserLanguage } from '../Utils/Utils';

export interface ILocalSharePayload {
    intent: string;
    image: string;
    text: string;
    data: any;
    surface?: string;
    media?: IMediaParams;
}

export const defaultFriend: IFBFriend = {
    userId: null,
    name: 'friend',
    avatar: 'mapui/no-avatar',
};

export const defaultContextPlayer: ContextPlayer = {
    getID(): string {
        return defaultFriend.userId;
    },
    getPhoto(): string {
        return defaultFriend.avatar;
    },
    getName(): string {
        return defaultFriend.name;
    },
};

export class SDKlocal {
    public readonly payments: ISDKpayments;
    // @ts-ignore
    private sdkSettings: ISGSettings;

    constructor() {
        this.payments = new SDKlocalpayments();
        this.sdkSettings = {
            abTesting: {},
            bannerUrl: {},
            crossPromotion: {
                enabled: false,
            },
            env: {
                type: 'local',
                locale: 'en',
                anotherTab: false,
            },
            game: {
                id: 'moji',
                slug: 'moji',
            },
            invite: {
                native: false,
            },
            moreGames: {
                displayButton: false,
            },
            purchase: {
                available: false,
                native: false,
            },
            rewarded: {
                enabled: true,
            },
            share: {
                native: false,
            },
        };
    }

    // @ts-ignore
    public showLoadProgress(prog: number) {
        // console.log('local load progress: ' + prog);
    }

    public getLocale() {
        return getBrowserLanguage();
    }

    public async loadComplete() {
        return {
            name: 'me',
            avatar: 'no avatar',
            userId: '111111199999999999999',
        };
    }

    public async retrieveData(key: string): Promise<any> {
        let n = null;
        await Storage.getFromStorage(key).then(res => {
            n = JSON.parse(res);
        });
        return n;
    }

    public storeData(key: string, value: any) {
        return Storage.saveToStorage(key, value);
    }

    public async getRandomFriend() {
        return defaultFriend;
    }

    public getContextPlayers(): ContextPlayer[] {
        return [defaultContextPlayer];
    }

    public async getAd(placement: string): Promise<string> {
        await waitForMs(2000);
        return Promise.resolve('get fake ad success: ' + placement);
    }

    public async showAd(instance: any) {
        await waitForMs(2000);
        return Promise.resolve('show fake ad success: ' + instance);
    }

    public async getFriends(): Promise<any> {
        return new Promise(resolve => {
            resolve('no friends here');
        });
    }
    public async showLoadedAd(): Promise<any> {
        return Promise.resolve();
    }

    public async askFriend(friend: IFBFriend, item: IRewardItem): Promise<any> {
        return true;
    }

    public getRewardedEnabled() {
        return this.sdkSettings.rewarded.enabled;
    }

    public async getLeaderBoardData(): Promise<any> {
        return new Promise(resolve => {
            resolve([]);
        });
    }

    public async setLeaderBoardData(): Promise<any> {
        return new Promise(resolve => {
            resolve('no leaderboards here');
        });
    }

    public async canSubscribeBots() {
        return new Promise(resolve => {
            resolve('no bots here');
        });
    }

    public async subscribeBots() {
        return new Promise(resolve => {
            resolve('no bots here');
        });
    }

    public async canCreateShortcut() {
        return new Promise(resolve => {
            resolve(false);
        });
    }

    public async createShortcut() {
        return new Promise(resolve => {
            resolve('no shortucts here');
        });
    }

    public async share(sharePayload: ILocalSharePayload) {
        return new Promise(resolve => {
            resolve('no sharing on local');
        });
    }

    public async sendCustomMessage() {}

    public async gameTracking(trackData: ISGTrackData) {
        return Promise.resolve('no tracking on local');
    }

    public async levelStart(level: number) {
        return Promise.resolve("can't track level start on local: " + level);
    }

    public async levelEnd(level: number, score: number, state: string) {
        return Promise.resolve(
            "can't track level end on local: " + level + ', score: ' + score + ', state: ' + state
        );
    }

    public getPlatform(): string {
        if (getIsWeb()) {
            return 'WEB';
        }

        return 'MOBILE_WEB';
    }

    public async getEntryPointData() {
        return Promise.resolve('entry on local');
    }

    public canSwitchGame() {
        return false;
    }

    /* public checkConnection() {
        return false;
    } */
}
